export default __webpack_public_path__ + "static/media/ColorFill.30cd931e.svg";